import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';
import { CurrencyFigure } from '../../Figure/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 's',
  title: '24h Volume (USD)'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get rightAlign() {
    return true;
  }
}


var DetailColumn = function(props) {
  return (
    <td className="text-right">
      <CurrencyFigure amount={props.row.tradingVolume24h} formatter="large" />
    </td>
  );
}


class TradingVolume24h extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get visible() {
    return false;
  }

  sortAscending(a, b) {
    if (a.tradingVolume24h < b.tradingVolume24h) {
      return -1;
    }
    if (a.tradingVolume24h > b.tradingVolume24h) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.tradingVolume24h < b.tradingVolume24h) {
      return 1;
    }
    if (a.tradingVolume24h > b.tradingVolume24h) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default TradingVolume24h;

